import { render, staticRenderFns } from "./airtime.vue?vue&type=template&id=e1c18ad0&scoped=true"
import script from "./airtime.vue?vue&type=script&lang=js"
export * from "./airtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c18ad0",
  null
  
)

export default component.exports